export default () => ({
  id: null,
  name: null,
});
